import { useState } from "react";
import { Button, Container, Form, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaStar, FaRegStar } from "react-icons/fa";
import Footer from '../Footer/Footer';

const WriteReview = () => {
  const [reviewType, setReviewType] = useState("Company"); // Default selection
  const [formData, setFormData] = useState({
    company: "",
    product: "",
    description: "",
    services: [],
    rating: 0
  });

  const [servicesList, setServicesList] = useState([
    {
      id: 1,
      name: 'Veritis Development Agency',
      image: 'https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4',
      staff: '10 - 49',
      location: 'New York, USA',
      budget: '$25,000+',
      hourrate: '$50 - $99/hr',
      rating: 4.5,
      review: 26,
      description: 'Veritis is a global IT consulting services provider...',
      services: ['Website Development', 'App Development', 'AWS', 'Azure', 'Design']
    }
  ]);

  const serviceOptions = ["Cloud Services", "Containerization Services", "DevOps Services", "Digital Transformation Services", "IAM Services", "Managed IT Services"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleServiceSelect = (service) => {
    setFormData(prev => ({
      ...prev,
      services: prev.services.includes(service)
        ? prev.services.filter(s => s !== service)
        : [...prev.services, service]
    }));
  };

  const handleRating = (index) => {
    setFormData({ ...formData, rating: index + 1 });
  };

  const handleDelete = (id) => {
    setServicesList(servicesList.filter(profile => profile.id !== id));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Review Submitted:", formData);
  };

  return (
    <>
        <section className="page-header no-header bg-skyblue py-2">
        <div className="container py-4 pb-2">
          <div className="row page-introduction">
            <div className="col-12">

              <div className="d-flex align-items-center justify-content-start">
                <div className="text-start">
                  <h3 className="mt-0">Write a Review</h3>
                  <p className="text-muted">Your review will help other buyers choose the best service providers for their business.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="js-pg-hg mb-5">
        <Container>
          <Form onSubmit={handleSubmit}>
            <div className="card p-5 rounded-4 shadow-sm">

              {/* Selection for Company or Product */}
              <Form.Group className="mb-4">
                <Form.Label className="fs-4 fw-500 mb-3">Looking to write a review for?</Form.Label>
                <div className="d-flex">
                  <Form.Check
                    type="radio"
                    label="Company"
                    name="reviewType"
                    value="Company"
                    checked={reviewType === "Company"}
                    onChange={() => setReviewType("Company")}
                    className="me-3"
                  />
                  <Form.Check
                    type="radio"
                    label="Product"
                    name="reviewType"
                    value="Product"
                    checked={reviewType === "Product"}
                    onChange={() => setReviewType("Product")}
                  />
                </div>
              </Form.Group>

              {/* Company or Product Name Field */}
              <Form.Group className="mb-3">
                <Form.Label>
                  {reviewType === "Company" ? "Which company are you looking to review?" : "Which product are you looking to review?"}
                </Form.Label>
                <Form.Control
                  type="text"
                  name={reviewType.toLowerCase()}
                  placeholder={reviewType === "Company" ? "Search company name" : "Search product name"}
                  value={formData[reviewType.toLowerCase()]}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              {/* Display Company List only if reviewing a Company */}
              {reviewType === "Company" && servicesList.map(profile => (
                <div className='col-12 mt-3' key={profile.id}>
                  <div className="d-lg-flex bg-light card rounded-4 p-3">
                    <div className='flex-grow-1'>
                      <div className='d-flex justify-content-between'>
                        <div className='d-flex align-items-center'>
                          <img src={profile.image} className="img-thumbnail rounded-3 border-1 me-4" alt={profile.name} style={{ maxWidth: '60px' }} />
                          <div>
                            <h6 className="card-title pb-0">{profile.name}</h6>
                            <span className="card-text rating">
                              <strong className="me-2">{profile.rating}</strong>
                              {[...Array(5)].map((_, index) =>
                                index < profile.rating ? (
                                  <FaStar key={index} className="text-warning" />
                                ) : (
                                  <FaRegStar key={index} className="text-warning" />
                                )
                              )}
                              <span className="ms-3 small">({profile.review} Reviews)</span>
                            </span>
                          </div>
                        </div>
                        <Button variant="danger" onClick={() => handleDelete(profile.id)}>Delete</Button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {/* Show Services selection only if reviewing a Company */}
              {reviewType === "Company" && (
                <Form.Group className="mt-4">
                  <Form.Label>Select Services</Form.Label>
                  <div className="mt-2">
                    {serviceOptions.map(service => (
                      <Badge key={service} pill bg={formData.services.includes(service) ? "primary" : "secondary"} className="me-2 px-3 pr-btn border-0 text-white cursor-pointer" onClick={() => handleServiceSelect(service)}>
                        {service}
                      </Badge>
                    ))}
                  </div>
                </Form.Group>
              )}

              {/* Review Feedback */}
              <Form.Group className="mt-4">
                <Form.Label>Can you write your review feedback?</Form.Label>
                <Form.Control as="textarea" name="description" rows={3} value={formData.description} onChange={handleChange} required />
              </Form.Group>

              {/* Star Rating */}
              <Form.Group className="mt-4">
                <Form.Label className="m-0 p-0">Rate</Form.Label>
                <div className="mb-4">
                  {[...Array(5)].map((_, index) => (
                    <span key={index} onClick={() => handleRating(index)} style={{ cursor: "pointer", fontSize: "1.5rem", marginRight: "5px" }}>
                      {index < formData.rating ? <FaStar className="text-warning" /> : <FaRegStar className="text-warning" />}
                    </span>
                  ))}
                </div>
              </Form.Group>

              <Button variant="primary" type="submit" className="resend_mx btn-lg" as={Link} to="/MyReviews">Submit Review</Button>
            </div>
          </Form>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default WriteReview;
